import React, { useState } from "react";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";
import RoleLoginForm from "../../components/RoleLoginForm/RoleLoginForm";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import {COMPLIANCE_ADMIN_ROLE_ID} from "../../constants/DataConstants";

const RoleLoginComplianceAdmin = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinishHandle = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
                IsBanker: "Compliance",
                RoleId: COMPLIANCE_ADMIN_ROLE_ID
            };
            const res = await _BankerService.bankerLogin(reqObj);
            if (res?.data?.IsSuccess) {
                localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
                localStorage.setItem("BankerEmailId", res?.data?.Obj?.Email);
                localStorage.setItem("BankerId", res?.data?.Obj?.Id);
                localStorage.setItem("BankerFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
                localStorage.setItem("IsFromNewLoginPage", routes.roleLoginComplianceAdmin.path);
                localStorage.setItem("listUserRoles", JSON.stringify(res?.data?.Obj?.listUserRoles));
                localStorage.setItem("Password", values.password);
                history.push(routes.complianceadmindashboard.path);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push({ pathname: routes.forgotBankerLoginPasswordSendOTP.path, state: { fromNewLoginPage: routes.roleLoginComplianceAdmin.path } });
    };

    return (
        <Spin spinning={loading}>
            <RoleLoginForm
                title="Compliance Admin Portal"
                onFinishHandle={onFinishHandle}
                forgotPassword={forgotPassword}
                isNewAccountCreateFlag={false}
                onBack={() => history.push(routes.loginNewPage.path)}
            />
        </Spin>
    );
};

export default RoleLoginComplianceAdmin;
